import React, {useEffect} from "react";
import SubTitle from "../../../components/SubTitle";
import {useForm, FormProvider, SubmitHandler, Controller} from "react-hook-form";
import {useCreateMutation, useGetItemQuery, useUpdateMutation} from "../../../hooks/useQueryHooks";
import {ResponseItem} from "../../../models/clientModels/interfaces/Response";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import * as examApi from "../../../api/educationApi/examApi";

import * as Params from "../../../models/clientModels/interfaces/apiParams";

import {useQueryClient} from "react-query";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {snackBarState, snackBarToggleState} from "../../../Recoil/Atom/snackBarState";
import ConfirmButtonGroup from "../../../components/ConfirmButtonGroup";
import {FormSection} from "../../../styledComponents/StyledCreateForm";
import MWProgress from "../../../components/MWProgress";
import {tokenSelector} from "../../../Recoil/Atom/authState";
import {yupResolver} from "@hookform/resolvers/yup";

import MWCaption from "../../../components/MWCaption";
import {Box, Grid, TextField, Typography, styled} from "@mui/material";
import {EDExam, excludeExamParam} from "../../../models/serverModels/education/EDExam";

const CategoryFormContainer = styled(Grid)(({theme}) => ({
  justifyContent: "center",
  alignItems: "center",
  marginTop: "16px",

  backgroundColor: "#fff",
  "& p": {
    marginTop: "8px",
    textAlign: "center",
  },
}));

const CategoryFormContent = styled(Grid)(({theme}) => ({
  display: "flex",
  flexFlow: "column",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  margin: "48px 0",

  padding: "36px",
  border: `1px solid ${theme.palette.background.paper}`,
  borderRadius: "16px",
  boxShadow:
    "rgb(0 0 0 / 10%) 0rem 0.25rem 0.375rem -0.0625rem, rgb(0 0 0 / 6%) 0rem 0.125rem 0.25rem -0.0625rem",

  "& label": {
    fontWeight: 600,
    paddingRight: "8px",
  },
}));

const DocumentList = styled(Box)(({theme}) => ({
  display: "flex",
  alignItems: "center",
  width: "100%",
  "& label": {
    flexBasis: "30%",
  },
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    alignItems: "flex-start",
  },
}));

const ExcludeExam = () => {
  const {id, uid} = useParams();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const tokenState = useRecoilValue(tokenSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const {mutate: excludeMutate, isLoading} = useCreateMutation<
    ResponseItem<EDExam>,
    excludeExamParam
  >({
    api: examApi.ExcludeExam,
    options: {
      onSuccess: () => {
        setSnackBarToggle(true);
        setSnackBarState("update");
        navigate(-1);
        queryClient.invalidateQueries("ExamRank");
      },
      onError: () => {
        setSnackBarToggle(true);
        setSnackBarState("failed");
      },
    },
  });
  const {reset, control, handleSubmit} = useForm<EDExam>();

  const onSubmit: SubmitHandler<EDExam> = (data) => {
    excludeMutate({
      id: parseInt(id!),
      uid: parseInt(uid!),
      token: tokenState,
      note: data.note,
    });
  };

  return (
    <React.Fragment>
      <SubTitle subTitle="평가제외" />
      {isLoading ? (
        <MWProgress />
      ) : (
        <FormSection>
          <form onSubmit={handleSubmit(onSubmit)}>
            <MWCaption title="평가제외" icon="" />
            <CategoryFormContainer container>
              <CategoryFormContent
                item
                xs={12}
                sm={12}
                md={6}
                xl={4}
                sx={{padding: {xs: "16px 4px", sm: "16px 8px", md: "24px"}}}
              >
                <Controller
                  name="note"
                  control={control}
                  render={({field, fieldState: {error}}) => (
                    <DocumentList>
                      <label htmlFor="name">비고 : </label>
                      <TextField
                        {...field}
                        value={field.value || ""}
                        id="note"
                        size="small"
                        placeholder="비고"
                        margin="dense"
                        autoFocus
                        required
                        sx={{width: "100%"}}
                      />
                      <Typography color="secondary">{error?.message}</Typography>
                    </DocumentList>
                  )}
                />
              </CategoryFormContent>
            </CategoryFormContainer>
            <ConfirmButtonGroup link={-1} cancelText="취소" confirmText="제외" />
          </form>
        </FormSection>
      )}
    </React.Fragment>
  );
};

export default ExcludeExam;
